import styles from './CreateNewAction.module.css'

import { MdAddCircleOutline } from '@react-icons/all-files/md/MdAddCircleOutline'
import React from 'react'
import { Link } from 'react-router-dom'

import { Flex, Text } from 'components/ds'

export interface CreateNewActionProps {
  /** The label text to display (e.g., "Create new writer") */
  label: string
  /** React Router v6 path */
  to: string
  /** Optional click handler */
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void
  /** Optional search text to pre-populate the name field in the modal */
  searchText?: string
  /** Optional split ID to identify which split row triggered the creation */
  splitId?: string | number
  /** Optional splits key (track ID or BULK_EDIT_KEY) for updating the correct split */
  splitsKey?: number | string
}

/**
 * CreateNewAction - A reusable action component for "Create new..." links in dropdowns
 *
 * This component displays a clickable link with an add icon and custom text,
 * commonly used as the actionComponent in SearchableDropdown components.
 *
 * @param props - Component props
 * @returns CreateNewAction component
 *
 * @example
 * ```tsx
 * <CreateNewAction
 *   label="Create new writer"
 *   onClick={(e) => {
 *     e.preventDefault()
 *     handleCreateWriter()
 *   }}
 * />
 * ```
 */
export function CreateNewAction({
  label,
  to,
  onClick,
  searchText,
  splitId,
  splitsKey,
}: CreateNewActionProps) {
  return (
    <Link
      to={to}
      state={{ searchText, splitId, splitsKey }}
      className={styles.actionLink}
      onClick={onClick}
    >
      <Flex align="center" gap="2">
        <Text size="2" color="blue" asChild>
          <MdAddCircleOutline size={16} />
        </Text>
        <Text size="2" color="blue">
          {label}
        </Text>
      </Flex>
    </Link>
  )
}

export default CreateNewAction
